import { get, put } from 'utils/fetchRequest';

// Бүх тохиргоог татна → { status, data: { list, map } }
export const getSettings = async (group) => {
    try {
        const result = await get(`settings${group ? `?group=${group}` : ''}`);
        return result;
    } catch (err) {
        return { error: err };
    }
};

// Багцаар хадгална. items: [{ key, value, group }]
export const saveSettings = async (items) => {
    try {
        const result = await put('settings', { items });
        return result;
    } catch (err) {
        return { error: err };
    }
};
